var $05e247fd2960981e$exports = {};
$05e247fd2960981e$exports = {
    "alpha": `Alfa`,
    "blue": `K\xe9k`,
    "brightness": `F\xe9nyess\xe9g`,
    "green": `Z\xf6ld`,
    "hue": `Sz\xedn\xe1rnyalat`,
    "lightness": `Vil\xe1goss\xe1g`,
    "red": `Piros`,
    "saturation": `Tel\xedtetts\xe9g`
};


export {$05e247fd2960981e$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
